<template>
  <div>
    <NavBar/>
    <div class="house_banner">
      <van-row type="flex" justify="center" class="house_details">
        <van-col :span="22" style="font-weight:bold">{{houseSite}}</van-col>
        <van-col :span="22" class="details_money">{{fundBal}}</van-col>
        <van-col :span="22" class="details_text">账户余额(元)</van-col>
      </van-row>
      <van-row type="flex" justify="left" class="house_Info_text">
        <van-col :span="24">房屋交易业务编号：{{contractNo}}</van-col>
        <van-col :span="24"><van-divider /></van-col>
        <van-col :span="24">建筑面积（㎡）：{{struArea}}</van-col>
        <van-col :span="24"><van-divider /></van-col>
        <van-col :span="24">交存标准（元/㎡）：{{ratio}}</van-col>
        <van-col :span="24"><van-divider /></van-col>
        <van-col :span="24">房屋类型：{{houseAttr}}</van-col>
        <van-col :span="24"><van-divider /></van-col>
        <!-- 足额的叫已交存  其他的叫代缴存 -->
        <!-- <van-col :span="24">交存状态：{{dueState=='1'?'足额':dueState=='2'?'多缴':dueState=='3'?'少交':dueState=='4'?'未交':dueState=='5'?'免交':''}}</van-col> -->
        <van-col :span="24">交存状态：{{dueState=='1'||dueState=='2'||dueState=='5'?'已交存':dueState=='3'||dueState=='4'?'待交存':''}}</van-col>
        <!-- <van-col :span="24"><van-divider /></van-col> -->
      </van-row>
      <!-- 代缴存才有 -->
      <div v-if="dueState=='3'||dueState=='4'">
        <div>
            <van-col span='24' style="text-align:center;font-weight:bold;color:red;font-size:20px">{{amountDue}}</van-col>
            <van-col span='24' style="text-align:center;margin-top:10px;font-size:13px;color:gray">应交金额(元)</van-col>
          </div>
          <div class="BtnFixed">
            <van-col :span="24" class="house_button">
                <van-button type="danger" size="normal" @click="openImat">立即支付</van-button>
            </van-col>
          </div>
      </div>
      
      <!-- 支付的弹出层 -->
      <!-- <van-action-sheet v-model:show="Popup" title="支付" :style="{ height: '60%' }">
            <div class="content">
                <van-col span='24' style="text-align:center;font-size:26px;font-weight:bold;color:skyblue">20000.00</van-col>
                <van-col span='24' style="text-align:center;font-size:12px;color:gray;margin-top:10px">交易金额(元)</van-col>
                <van-col span='24' style="margin-top:35px">
                  <van-cell :value="payText" is-link @click="openShow">
                    <template #title>
                        <span class="custom-title">请选择支付方式</span>
                    </template>
                  </van-cell>
                  <van-popup v-model:show="showPicker" position="bottom">
                    <van-picker :columns="columns"  @confirm="onConfirm"  @cancel="showPicker = false"/>
                  </van-popup>
                </van-col>
                <div class="flexSon">
                  <van-col :span="24" class="house_button">
                    <van-button type="danger" size="normal"  @click="openPay">立即支付</van-button>
                  </van-col>
                </div>
            </div>
        </van-action-sheet> -->
      <!--  -->
    </div>
    
  </div>
</template>
<script>
import VueCookie from 'vue-cookie'
// import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      houseSite222:'',
      houseId:'',
      houseSite:'',
      fundBal:'',
      contractNo:'',
      struArea:'',
      ratio:'',
      houseAttr:'',
      dueState:'',
      amountDue:'',
      showIn:false,
      houseInfo:{},
      Popup:false,
      payText:'微信零钱',
      showPicker:false,
      columns: [{ text: '微信零钱', id:"1"},{text:'建设银行卡支付',id:'2'}],
    }
  },
  // beforeRouteEnter(to, from, next){
  //   // this.ssss()
  //   next(vm=>{
  //     console.log({...vm})
  //     vm.sss()
  //   })
  // },
  // beforeRouteEnter(to, from, next){
  //   // this.$nextTick(()=>{
  //       // console.log(to.query.houseSite)
  //     // this.houseSite222 = to.query.houseSite
  //     // console.log(this.houseSite222)
  //     // console.log(this.$route.query)
  //     next(vm => {
  //       console.log({...vm})
  //       vm.houseSite = to.query.houseSite
  //       vm.fundBal = to.query.fundBal
  //       vm.contractNo = to.query.contractNo
  //       vm.struArea =to.query.struArea
  //       vm.ratio = to.query.ratio
  //       vm.houseAttr = to.query.houseAttr
  //       vm.dueState = to.query.dueState
  //       vm.amountDue = to.query.amountDue
  //       vm.houseId = to.query.houseId
  //     })
  //     // this.fundBal = to.query.fundBal
  //     // this.contractNo = to.query.contractNo
  //     // this.struArea =to.query.struArea
  //     // this.ratio = to.query.ratio
  //     // this.houseAttr = to.query.houseAttr
  //     // this.dueState = to.query.dueState
  //     // this.amountDue = to.query.amountDue
  //     // this.houseId = to.query.houseId
  //     next()
  //   // })
    
  // },
  // mounted(){
  //   // console.log('11112222')
  //   this.sss()
  //   this.houseSite = this.$route.query.houseSite
  //   this.fundBal = this.$route.query.fundBal
  //   this.contractNo = this.$route.query.contractNo
  //   this.struArea = this.$route.query.struArea
  //   this.ratio = this.$route.query.ratio
  //   this.houseAttr = this.$route.query.houseAttr
  //   this.dueState = this.$route.query.dueState
  //   this.amountDue = this.$route.query.amountDue
  //   this.houseId = this.$route.query.houseId
  // },
  methods: {
    onConfirm(value) {
      this.payValue = value.id;
      this.payText = value.text;
      this.showPicker = false;
    },
    // sss(){
    //    console.log('11112222')
    //      this.houseSite = this.$route.query.houseSite
    //     this.fundBal = this.$route.query.fundBal
    //     this.contractNo = this.$route.query.contractNo
    //     this.struArea = this.$route.query.struArea
    //     this.ratio = this.$route.query.ratio
    //     this.houseAttr = this.$route.query.houseAttr
    //     this.dueState = this.$route.query.dueState
    //     this.amountDue = this.$route.query.amountDue
    //     this.houseId = this.$route.query.houseId
    // },
    //立即支付的方法
    imatePay(){
      var _this=this;
      let data={
        openId:VueCookie.get('openid'),
        // openId:'okLBP6Pdn1tAK_8OSPl6Zf9uOsN4',
        roomNo:this.houseId,
        contractNo:this.contractNo,
        totalFee:parseFloat(this.amountDue)*100,
      }
      this.$postQuery('/WeChatPay/createOrder', data).then((response) => {
        WeixinJSBridge.invoke('getBrandWCPayRequest', {
          appId:response.obj.appId ,     //公众号ID，由商户传入     
          timeStamp: response.obj.timeStamp,     //时间戳，自1970年以来的秒数     
          nonceStr: response.obj.nonceStr,      //随机串     
          package: response.obj.package,
          signType: response.obj.signType,     //微信签名方式：
          paySign: response.obj.paySign, //微信签名 
        },
        function(res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
                _this.$router.replace({
                  path:'/DepositDetails'
                })
            }
        })
      })
    },
    /**
     * 立即支付
     */
    openImat(){
      var _this=this;
      // let data={
      //   openId:VueCookie.get('openid'),
      //   roomNo:this.houseId,
      //   contractNo:this.contractNo,
      //   totalFee:parseFloat(this.amountDue)*100,
      // }
      // this.$postQuery('/WeChatPay/createOrder', data).then((response) => {
      //   WeixinJSBridge.invoke('getBrandWCPayRequest', {
      //     appId:response.obj.appId ,     //公众号ID，由商户传入     
      //     timeStamp: response.obj.timeStamp,     //时间戳，自1970年以来的秒数     
      //     nonceStr: response.obj.nonceStr,      //随机串     
      //     package: response.obj.package,
      //     signType: response.obj.signType,     //微信签名方式：
      //     paySign: response.obj.paySign, //微信签名 
      //   },
      //   function(res) {
      //       if (res.err_msg == "get_brand_wcpay_request:ok") {
      //           _this.$router.replace({
      //             path:'/DepositDetails'
      //           })
      //       }
      //   })
        // }
        if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', _this.imatePay(), false);
            } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', _this.imatePay());
                document.attachEvent('onWeixinJSBridgeReady', _this.imatePay());
            }
        } else {
          _this.imatePay()
        }
      // })
       
        // wx.chooseWXPay({
        //   timestamp: response.obj.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        //   nonceStr: response.obj.nonceStr, // 支付签名随机串，不长于 32 位
        //   package: response.obj.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        //   signType:response.obj.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        //   paySign: response.obj.paySign, // 支付签名
        //   success: function (res) {
        //     // 支付成功后的回调函数
        //     _this.$router.replace({
        //       path:'/DepositDetails'
        //     })
        //     console.log(res);
        //   }
        // });
      // })
    },
    /**
     * 打开选择支付的渠道
     */
    openShow(){
      this.showPicker = true
    },
    /**
     * 第二个立即支付
     */
    openPay(){
      let data = {
        payValue:this.payValue
      }
      console.log(data)
      // this.showPicker = true
    },
    
  },
  created() {
    this.houseSite = this.$route.query.houseSite
    this.fundBal = this.$route.query.fundBal
    this.contractNo = this.$route.query.contractNo
    this.struArea = this.$route.query.struArea
    this.ratio = this.$route.query.ratio
    this.houseAttr = this.$route.query.houseAttr
    this.dueState = this.$route.query.dueState
    this.amountDue = this.$route.query.amountDue
    this.houseId = this.$route.query.houseId
    // console.log(this.houseId,'1111111111111111111111111111111111')
  },
}
</script>
<style scoped>
  .house_banner{
    margin-top: 28px;
    width: 100%;
    height: 0;
    padding-top: 50%;
    background: linear-gradient(to right,#efa665,#d25f2b);
  }
  .house_details{
    position: absolute;
    top: 46px;
    left: 0;
    padding:10% 0;
    color: #fff;
    font-size: 14px;
    width: 100%;
    text-align: center;
  }
  .details_money{
    font-size: 18px;
    font-weight: bold;
    padding-top: 5%;
  }
  .details_text{
    padding-top: 3%;
  }
  .house_Info_text{
    padding: 30px 15px;
    font-size: 13px;
    color: #444;
  }
  .BtnFixed{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
  .BtnFixed .house_button{
    margin: 10px;
  }
  .BtnFixed  .house_button .van-button,.content_button .van-button{
    padding: 3px 15px;
    width: 100%;
  }
  .content {
    padding: 40px 16px 160px 16px;
  }
  .flexSon{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
  }
  .flexSon .house_button{
        margin: 10px;
  }
  .flexSon .house_button .van-button,.content_button .van-button{
      padding: 3px 15px;
      width: 100%;
  }
</style>